import React, { memo } from "react";
import Navbar from "./Navbar";
function Header() {
  return (
    <div className="header">
      <Navbar />
    </div>
  );
}

export default memo(Header);
